export const Z_INDEX_DEFAULT = 10

export const OFFSET_TOP = {
  HEADER_MENU: 0,
  HEADER_SEARCH: 88,
  HEADER_SEARCH_IN_MOBILE: 56,
}

export const STICKY_Z_INDEX = {
  SEARCH_IN_MOBILE: Z_INDEX_DEFAULT + 6,
  LOCALIZATION: Z_INDEX_DEFAULT + 5,
  MENU: Z_INDEX_DEFAULT + 4,
  SEARCH: Z_INDEX_DEFAULT + 3,
  SIDE_BAR: Z_INDEX_DEFAULT + 2,
  BREADCRUMB: Z_INDEX_DEFAULT + 1,
  YELLOW_BANNER: 2,
}

export const STICKY_STATUS = {
  STATUS_ORIGINAL: 0,
  STATUS_RELEASED: 1,
  STATUS_FIXED: 2,
}
